import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';

export const SwipeableViewsStyled = styled(SwipeableViews)`
  &,
  .react-swipeable-view-container {
    height: 100%;
  }
`;
